import Marquee from "react-fast-marquee";

const TERMS = [
  "SYNTHETIC APERTURE RADAR",
  "NDVI",
  "AIS FUSION",
  "SEA SURFACE TEMPERATURE",
  "SOIL MOISTURE",
  "MARITIME DOMAIN AWARENESS",
  "CHLOROPHYLL-A",
  "DARK VESSEL DETECTION",
  "EVAPOTRANSPIRATION",
  "COASTAL EROSION",
  "CROP CLASSIFICATION",
  "OIL SPILL SIGNATURE",
];

export default function EditorialMarquee() {
  return (
    <section className="border-y border-white/10 bg-arjuna-ink py-6" data-testid="marquee">
      <Marquee gradient={false} speed={38} autoFill>
        {TERMS.map((t, i) => (
          <span key={i} className="mx-8 flex items-center gap-8">
            <span
              className="font-mono text-2xl uppercase tracking-tight text-transparent sm:text-4xl"
              style={{ WebkitTextStroke: "1px rgba(148,163,184,0.45)" }}
            >
              {t}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-arjuna-teal/60" />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
